<template>
  <div class="blog-posts-page posts">
    <div class="post-list-header row pt-3  align-items-center mb-4">
      <div
        class="page-header col-12 d-flex justify-content-between align-items-center"
      >
        <div class="page-header-left d-flex align-items-center">
          <h1 class="w-full mr-2">Categories</h1>
        </div>
        <span
          class="header-right-side d-flex justify-content-center align-items-center"
        >
          <div class="input-group mr-3">
            <input
              class="form-control"
              type="text"
              v-model="newCategory.name"
              placeholder="Category name"
            />
          </div>
          <div class="input-group mr-3">
            <input
              class="form-control"
              type="text"
              v-model="newCategory.path"
              placeholder="Category path"
            />
          </div>
          <button class="btn btn-primary" @click.prevent="addCategory()">
            <b>Save</b>
          </button>
        </span>
      </div>
    </div>
    <div v-if="categories && categories.length" class="row">
      <div v-for="category in categories" :key="category.id" class="col-md-4">
        <div
          class="category-container d-flex justify-between align-items-center"
        >
          <strong>{{ category.name }}</strong>
          <div class="options-buttons">
            <button
              type="button"
              class="btn btn-secondary"
              @click="deleteCategory(category.id)"
            >
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="categories && !categories.length && !categoriesLoading"
      class="claims"
    >
      No categories added.
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Categories",
  data: () => ({
    newCategory: {
      name: "",
      path: ""
    },
    categories: [],
    keyword: "",
    meta: {},
    page: 1,
    q: "",
    showFilters: false,
    categoriesLoading: false
  }),
  mounted() {
    this.getCategories();
  },
  methods: {
    getCategories() {
      this.categoriesLoading = true;
      axios
        .get("/categories")
        .then(resp => {
          this.categories = resp.data.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.categoriesLoading = false;
        });
    },
    addCategory() {
      axios
        .post("/categories", { ...this.newCategory })
        .then(() => {
          this.$vToastify.success("Category added.");
          this.getCategories();
          this.newCategory.name = "";
          this.newCategory.path = "";
        })
        .catch(error => {
          this.$vToastify.error(error.message, "Error");
        });
    },
    deleteCategory(categoryId) {
      axios
        .delete(`/categories/${categoryId}`)
        .then(() => {
          this.$vToastify.success("Category deleted.");
          this.getCategories();
        })
        .catch(error => {
          this.$vToastify.error(error.message, "Error");
        });
    },
    togglePost(value) {
      if (this.expanded.includes(value)) {
        const index = this.expanded.indexOf(value);
        if (index > -1) {
          this.expanded.splice(index, 1);
        }
      } else {
        this.expanded.push(value);
      }
    },
    toggleAllPosts() {
      if (!this.expanded.length) {
        this.blogPosts.forEach(post => {
          this.expanded.push(post.id);
        });
      } else {
        this.expanded = [];
      }
    },
    viewMiddle(event, id) {
      const routeData = this.$router.resolve({
        path: `/posts/${id}`
      });
      window.open(routeData.href, "_blank");
    },
    view(event, id) {
      this.$router.push(`/posts/${id}`);
    }
  }
};
</script>
<style scoped>
.category-container {
  background-color: #fff;
  border-radius: 2px;
  margin-bottom: 10px;
  padding: 10px 30px;
}
.cateogry-title {
  font-weight: 600;
  font-size: 16px;
  color: #4c5669;
}
</style>
